export default __webpack_public_path__ + "static/media/7s.da573639.svg";